/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
// BASE Components
import BASESvgIcon from "../../../../@BASE/core/BASESvgIcon";
// material-ui
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/Menu';

function EmptyCommentsCard(props) {

    const { resource, global } = props;

    return (
        <Paper elevation={0} variant="outlined" className="p-8 flex flex-col items-center w-full rounded-16">
            <BASESvgIcon size={24}>
                heroicons-outline:exclamation
            </BASESvgIcon>
            <Typography className="text-12 font-medium" color="text.secondary">
                    There are no {global ? "global " : ""}comments for this {resource}.
            </Typography>
        </Paper>
    );
}

export default EmptyCommentsCard;
